"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrowR = void 0;
exports.arrowR = {
    path: "M8.08711 5L6.91211 6.175L10.7288 10L6.91211 13.825L8.08711 15L13.0871 10L8.08711 5Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
